module.exports = __webpack_public_path__ + "static/media/dropDownAerrow.8be2f005.svg";